var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMoodStroke2 = function SvgMoodStroke2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54.442,
    height: 54.442,
    viewBox: "0 0 54.442 54.442",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_725",
    "data-name": "Caminho 725",
    d: "M101.376,44.248A27.229,27.229,0,1,1,86.4,58.734a27.118,27.118,0,0,1,14.977-14.486Zm19.476,3.464a23.834,23.834,0,1,0,12.667,13.105,23.764,23.764,0,0,0-12.667-13.105Zm4.677,29.029a1.7,1.7,0,1,1-3.054,1.474,12.361,12.361,0,0,0-22.229,0,1.7,1.7,0,0,1-3.054-1.474,15.759,15.759,0,0,1,28.337,0Z",
    transform: "translate(-84.139 -42.345)",
    stroke: "none"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoodStroke2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/moodStroke2.aaaa8863.svg";
export { ForwardRef as ReactComponent };